<div class="containercodeverification">
  <div class="rowverification">

    <code-input [isCodeHidden]="show" [codeLength]="6" [isCharsCode]="false" (codeChanged)="onCodeChanged($event)"
      (codeCompleted)="onCodeCompleted($event)">
    </code-input>
    <button mat-icon-button aria-label="Example icon-button with a heart icon" (click)="changeShow()">
      <svg-icon src="assets/images/icons/preview.svg" [svgStyle]="{ 'width.px':32 }"></svg-icon>
    </button>
  </div>
</div>